import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CreateRoomType } from "../schema/CreateRoomTypeSchema";
import { ValidationErrorResponseCreateRoomType } from "../response/ValidationErrorResponseCreateRoomType";
import { CreateRoomTypeResponseSchema } from "../response/CreateRoomTypeResponse";

export const useCreateRoomType = () => {
    return useMutation({
        mutationFn: async (formData: CreateRoomType) => await privateApi.post(`/v4/room-type`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = CreateRoomTypeResponseSchema.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid room type data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create room type', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponseCreateRoomType.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room type data format");
            } else {
                console.error(`Failed to create room type`, error);
                throw error;
            }
        }
    });
};